import { createRoutes, str, int } from '../typesafe-routes';
import { oldJsonParam } from './utils';

export const hubRoutes = createRoutes({
  'login-fail': {
    path: ['login-fail'],
  },
  students: {
    path: ['students'],
    children: {
      '[studentId]': {
        path: [str('studentId')],
        children: {
          courses: {
            path: ['courses'],
          },
          learning: {
            path: ['learning'],
          },
          payment: {
            path: ['payment'],
          },
          report: {
            path: ['report'],
          },
          records: {
            path: ['records'],
            children: {
              '[studentRecordId]': {
                path: [str('studentRecordId')],
                children: {
                  edit: {
                    path: ['edit'],
                  },
                },
              },
              create: {
                path: ['create'],
              },
            },
          },
        },
      },
    },
  },
  'purchase-history': {
    path: ['purchase-history'],
    query: [int.optional('offset'), int.optional('limit'), oldJsonParam().optional('searchFilter')],
    children: {
      '[purchaseId]': {
        path: [str('purchaseId')],
        children: {
          'sales-counseling-record': {
            path: ['sales-counseling-record'],
            children: {
              create: {
                path: ['create'],
              },
              '[salesCounselingRecordId]': {
                path: [str('salesCounselingRecordId')],
                children: {
                  edit: {
                    path: ['edit'],
                  },
                },
              },
            },
          },
        },
      },
    },
  },
});
